import React, { useState, useEffect } from 'react'
import Dialog from '@material-ui/core/Dialog'
import DialogContent from '@material-ui/core/DialogContent'
import Slide from '@material-ui/core/Slide'
import DialogTitle from '@material-ui/core/DialogTitle'
import Fab from '@material-ui/core/Fab'
import { MdClose } from 'react-icons/md'
import { categoriesService } from '../../../_services/categories.service'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import Checkbox from '@material-ui/core/Checkbox'
import { toastr } from 'react-redux-toastr'

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />
})

const SelectForPrintModal = props => {
  const [loading, setLoading] = useState(false)
  const [compactPrint, setCompactPrint] = useState(true)
  const [data, setData] = useState([])
  const [selected, setSelected] = useState(props.selectedCategoriesForPrint)
  const [open, setOpen] = useState(props.open)

  useEffect(() => {
    if (props.open) {
      getData()
      setSelected(props.selectedCategoriesForPrint)
    } else {
      setData([])
      setSelected([])
    }
    setOpen(props.open)
  }, [props.open, props.selectedCategoriesForPrint])

  const getData = () => {
    setLoading(true)

    categoriesService
      .getAll(0)
      .then(res => {
        console.log(res.data)
        setData(res.data)
        setLoading(false)
      })
      .catch(err => {
        console.log(err)
        setLoading(false)
      })
  }

  const handleCloseModal = () => {
    props.onClose()
  }

  const handleCloseModalAndSelectTasks = () => {
    if (selected.length > 0) {
      props.handleCloseModalAndSelectTasks(selected, compactPrint)
    } else {
      toastr.warning('لطفا حداقل یک دسته بندی انتخاب کنید')
    }
  }

  return (
    <React.Fragment>
      <Dialog
        open={open}
        onClose={() => handleCloseModal()}
        TransitionComponent={Transition}
        scroll={'paper'}
        // fullScreen={true}
        fullWidth={true}
        maxWidth="lg">
        <DialogTitle>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between'
            }}>
            <div>
              <Fab
                color="secondary"
                aria-label="refresh"
                size="small"
                onClick={() => handleCloseModal()}
                className="modal-close-btn">
                <MdClose size="20px" />
              </Fab>
              <span style={{ marginRight: 10 }}>
                دسته بندی مورد نظر جهت پرینت را انتخاب کنید
              </span>
            </div>
            <FormControlLabel
              control={
                <Checkbox
                  size="medium"
                  checked={compactPrint}
                  onChange={() => {
                    setCompactPrint(!compactPrint)
                  }}
                  name="selectFromList"
                  color="primary"
                />
              }
              label="پرینت فشرده"
            />
          </div>
        </DialogTitle>
        <DialogContent dividers={true} className="modal-gray-bg">
          <div
            style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap' }}>
            {data &&
              data.length > 0 &&
              data.map((item, index) => (
                <div style={{ width: '25%' }}>
                  <FormControlLabel
                    key={`checkbox-${index}`}
                    control={
                      <Checkbox
                        size="medium"
                        checked={selected.includes(item.id)}
                        onChange={() => {
                          let arr = selected
                          let newArray = []
                          const index = selected.findIndex(el => el === item.id)
                          if (index === -1) {
                            newArray = [...arr, item.id]
                          } else {
                            newArray = arr.filter(el => el !== item.id)
                          }
                          setSelected(newArray)
                        }}
                        name="selectFromList"
                        color="primary"
                      />
                    }
                    label={item.name}
                  />
                </div>
              ))}
          </div>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              width: '100%'
            }}>
            <a
              className="btn btn-primary"
              onClick={() => handleCloseModalAndSelectTasks()}>
              ادامه و انتخاب سفارشات
            </a>
          </div>
        </DialogContent>
      </Dialog>
    </React.Fragment>
  )
}

export default SelectForPrintModal
